<div class="container" [ngSwitch]="mode"> 
  <div *ngSwitchDefault>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width:100%">
      <tr  class="back">
        <th>S/N</th>
        <th>Name</th>
        <th>Gender
          <!-- <input type="text" class="form-control" id="search-text" aria-describedby="search-text" 
            [(ngModel)]="searchText" placeholder="Search" 
            autofocus
          > -->
        </th>
        <th>
          <button class="add" mat-raised-button color="basic" (click)="addNew()">
            Add New
          </button>
        </th>
      </tr>
      <tr class="td" *ngFor="let title of filterddata">
        <td>{{title.id}}</td>
        <td>{{title.name}}</td>
        <td>{{title.gender}}</td>
        <td>
          <button mat-raised-button color="primary" (click)="edit(title)">
            Edit
          </button>
          <button mat-raised-button color="primary" style="margin-left: 5px;" (click)="delete(title)">
            Delete
          </button>
        </td>
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
          <p>{{Errors}}</p>
      </div>
    </div>
    <div class="last">
    </div>
  </div>
  <form [formGroup]="titleForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'add'">
    <div class="post">
      <div class="title">Create Title</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
              <mat-label>Name</mat-label>
              <input required formControlName="name" matInput placeholder="Mr">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Gender</mat-label>
              <select required formControlName="gender" matNativeControl required>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </mat-form-field>
      </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
    </div>
    <div class="errorMessage">
      <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
      </div>
  </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading? "Saving...": "Save"}}
        </button>
      </div>
    </div>
  </form>
  <form [formGroup]="titleForm" (ngSubmit)="onEdit($event)" class="post" *ngSwitchCase="'edit'">
    <div class="post">
      <div class="title">Edit Title</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
              <mat-label>Name</mat-label>
              <input formControlName="name" matInput placeholder="Mr">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Gender</mat-label>
              <select formControlName="gender" matNativeControl required>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </mat-form-field>
      </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
            <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading? "Saving...": "Save"}}
        </button>
      </div>
    </div>
  </form>
  
</div>